import { Outlet } from 'react-router-dom'

import Sidebar from './Sidebar'

export default function Layout() {
  return (
    <div className="h-full flex bg-page">
      <Sidebar />
      <main className="flex-1 min-w-0 p-4 overflow-hidden">
        <div className="h-full card overflow-hidden flex flex-col">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
